<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-card
        elevation="0"
        :class="[
          'food-card-content',
          { 'on-hover': hover, 'order-food-selected': isSelected },
        ]"
        :disabled="disabled"
        @click.prevent="showFoodDetails"
      >
        <v-row>
          <v-col cols="auto" class="pr-0">
            <template v-if="getImageSrc">
              <v-img width="80" height="80" class="rounded-lg" :src="getImageSrc" />
            </template>
            <template v-else>
              <v-sheet
                width="80"
                height="80"
                color="grey lighten-4"
                class="d-flex align-center justify-center"
                elevation="0"
              >
                <v-icon size="36" color="rgba(0, 0, 0, 0.26)">mdi-food</v-icon>
              </v-sheet>
            </template>
          </v-col>
          <v-col align="start" class="font-weight-bold pl-1">
            <v-row no-gutters justify="center" class="flex-column fill-height pl-2">
              <p :class="device.isDesktop ? 'subtitle-2' : 'body-1'" class="mb-0">
                {{ translate(item.name) }}
              </p>
              <span class="text-caption text-secondary" v-if="item.note">
                {{ item.note }}
              </span>
            </v-row>
          </v-col>
          <v-col
            cols="auto"
            align="start"
            class="font-weight-bold pr-2"
            v-if="!device.isDesktop"
          >
            <v-row
              no-gutters
              align="center"
              class="fill-height flex-column"
              justify="center"
            >
              <v-btn
                class="btn-plus"
                :class="btnClass"
                icon
                :disabled="disabled"
                @click.stop="onFoodToggled"
              >
                <v-icon :color="iconColor">
                  {{ iconName }}
                </v-icon>
              </v-btn>
              <span v-if="isSelected" class="food-quantity font-weight-medium"> 1x </span>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-hover>
    <category-menu-food-card-details
      v-model="showDetails"
      :food="item"
      :date="currentDate"
      :shift-label="shiftLabel"
      :is-selected="isSelected"
      :locked="isCategorySelected && !isSelected"
      @onFoodToggled="onFoodToggled"
    />
  </div>
</template>

<script>
import conf from "@/config";
import CategoryMenuFoodCardDetails from "@/components/categoryMenu/CategoryMenuFoodCardDetails.vue";
export default {
  components: { CategoryMenuFoodCardDetails },
  props: {
    item: {
      type: Object,
      required: true,
    },
    selectedFoods: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isCategorySelected: {
      type: Boolean,
      default: false,
    },
    date: String,
    shiftLabel: String,
  },
  data() {
    return {
      conf,
      showDetails: false,
    };
  },
  computed: {
    getImageSrc() {
      const img = this.item && this.item.image;
      if (img && img.restaurant_id && img.name) {
        return (
          this.conf.apiUrlBase + "/gallery/" + img.restaurant_id + "/medium/" + img.name
        );
      }
      return null;
    },
    btnClass() {
      if (this.isSelected) return "btn-deselect";
      if (this.isCategorySelected) return "btn-lock";
      return "btn-select";
    },
    iconColor() {
      if (this.isSelected) return this.$vuetify.theme.currentTheme.error;
      if (this.isCategorySelected) return "rgba(0, 0, 0, 0.12)";
      return this.$vuetify.theme.currentTheme.success;
    },
    iconName() {
      if (this.isSelected) return "mdi-minus";
      if (this.isCategorySelected) return "mdi-lock";
      return "mdi-plus";
    },
    currentDate() {
      // fallback to today if not provided
      return this.date || new Date().toISOString().substr(0, 10);
    },
  },
  methods: {
    showFoodDetails() {
      if (!this.device.isDesktop) {
        this.showDetails = true;
      }
    },
    onFoodToggled() {
      this.$emit("foodToggled");
      if (!this.isCategorySelected || this.isSelected) {
        // this.$emit("foodToggled");
      }
    },
    onAddFromDetails({ food, quantity }) {
      // You can emit with quantity if needed, for now just emit foodToggled
      this.$emit("foodToggled");
      this.showDetails = false;
    },
    imageNewUrl(index) {
      this.selectedMenu[this.shiftAsText][this.category][index].image = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

// Food card content
.food-card-content {
  border-radius: 16px !important;
}

// Selected food card
.order-food-selected {
  background: rgba($success-color, 0.1);
  border: 1px solid $primary-light;
}

// Food quantity badge
.food-quantity {
  position: absolute;
  top: 16px;
}

// Plus/minus button
.btn-plus {
  border-radius: 6px !important;
  min-width: 32px;
  height: 32px;
  box-shadow: none !important;
  padding: 0 8px;
}

// Button variants
.btn-select {
  background-color: rgba($success-color, 0.1) !important;
}

.btn-deselect {
  background-color: rgba($error-color, 0.1) !important;
}

.btn-lock {
  cursor: not-allowed;
}
</style>
